export type FilterAction =
  | { type: 'toggle-style'; style: string }
  | { type: 'toggle-size'; size: string }
  | { type: 'toggle-material'; material: string }
  | { type: 'toggle-dial'; dial: string }
  | { type: 'set-page'; page: number }
  | { type: 'reset'; fixed?: { [key: string]: string[] } }

export interface FilterState {
  style: string[]
  size: string[]
  material: string[]
  dial: string[]
  page: number
}

export function reducer(state: FilterState, action: FilterAction): FilterState {
  switch (action.type) {
    case 'toggle-style':
      return {
        ...state,
        page: 0,
        style: state.style.includes(action.style)
          ? state.style.filter(s => s !== action.style)
          : [...state.style, action.style]
      }
    case 'toggle-size':
      return {
        ...state,
        page: 0,
        size: state.size.includes(action.size)
          ? state.size.filter(s => s !== action.size)
          : [...state.size, action.size]
      }
    case 'toggle-material':
      return {
        ...state,
        page: 0,
        material: state.material.includes(action.material)
          ? state.material.filter(s => s !== action.material)
          : [...state.material, action.material]
      }
    case 'toggle-dial':
      return {
        ...state,
        page: 0,
        dial: state.dial.includes(action.dial)
          ? state.dial.filter(s => s !== action.dial)
          : [...state.dial, action.dial]
      }
    case 'set-page':
      return {
        ...state,
        page: action.page
      }
    case 'reset':
      return {
        style: [],
        size: [],
        material: [],
        dial: [],
        ...action.fixed,
        page: 0
      }
    default:
      return state
  }
}
